//@flow

import type { IncomingPayment } from '@tectonics/prs/incoming-payment/types';

export function getStatusDate(incomingPayment: IncomingPayment): ?string {
  return incomingPayment['status_date'];
}
